import fetchJson from './fetch-json';
import Cookies from 'js-cookie';

const isServer = typeof window === 'undefined';

const API_BASE = isServer ?
  process.env.API_BASE :
  window.API_BASE;

const JS_API_APPLICATION_KEY = isServer ?
  process.env.JS_API_APPLICATION_KEY :
  window.JS_API_APPLICATION_KEY || 'dev-b2c-key';

function performRequest(ctx, url, options = {}) {
  if (url[0] !== '/') {
    url = `/${url}`;
  }

  const opts = {
    credentials: 'same-origin',
    ...options,
    headers: {
      ...options.headers,
      'X-Application-Capabilities': '3ds',
      'X-Application-Identifier': JS_API_APPLICATION_KEY,
      'X-Accept-Language': ctx.i18n.locale || '',
      'X-User-Agent': ctx.userAgent,
    },
  };

  if (ctx.session.token) {
    opts.headers['X-User-Identifier'] = ctx.session.token;
  }

  return fetchJson(`${API_BASE}${url}`, opts);
}

export class SDK {
  constructor(ctx) {
    this.ctx = ctx;
  }

  getUrl(url) {
    if (url[0] !== '/') {
      url = `/${url}`;
    }
    const sep = url.indexOf('?') > -1 ? '&' : '?';
    return `/api${url}${sep}key=${JS_API_APPLICATION_KEY}`;
  }

  get(url, options) {
    return performRequest(this.ctx, url, {
      ...options,
      method: 'GET',
    });
  }

  post(url, body, options) {
    return performRequest(this.ctx, url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options && options.headers,
      },
      body: JSON.stringify(body),
      method: 'POST',
    });
  }

  put(url, body, options) {
    return performRequest(this.ctx, url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options && options.headers,
      },
      body: JSON.stringify(body),
      method: 'PUT',
    });
  }

  delete(url, body, options) {
    return performRequest(this.ctx, url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options && options.headers,
      },
      body: JSON.stringify(body),
      method: 'DELETE',
    });
  }

  toJSON() { return undefined; }
}

export default function createSdkInstance(ctx) {
  return new SDK(ctx);
}



// WEBPACK FOOTER //
// ./spa/sdk.jsx